import prefs, { Language, ModelRole } from '@/controllers/preferences'

import { type Message } from '@/components/Chat/Message';

export function truncateMessages(messages) {
  // image and audio types coming from jupyter include huge data url
  // also, html type is unnecessary for jupyter since that is usually accompanied by text type
  const filteredMessages = messages.filter((m) => m.type === "text" || m.type === "md" || m.type === "py")

  return filteredMessages.map((m) => {
    return {role: m.role, type: m.type, content: m.content.slice(0,1000)}
  })
}

export function makePrompt(lesson: {title: string, prompt: string}, role: ModelRole, language: Language, messages: Message[]) {
    console.log(role)

    const truncatedMessages = truncateMessages(messages);
  return `
Your role:
${prefs.model_roles[role]}

SPEAK IN ${language.toUpperCase()}

**Lesson Topic:** ${lesson.title}

${lesson.lesson_plan || lesson.prompt}

Always speak in ${language.toUpperCase()}, no matter what the student speaks in or what your previous messages were in.

Always make sure to follow your role, no matter what your previous messages were.

Note that you are a large language model, so you might have trouble with certain things
like symbol manipulation (for example, checking exact spelling of words)
and math with large numbers. Fortunately, you have access to a jupyter notebook environment
to run your code in. Just create a markdown code block with python code result of which you want
to check and it will be executed automatically.

Discussion so far:

${JSON.stringify(truncatedMessages)}

\\nothink`
}